import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PanForm = () => {
  const [name, setName] = useState("");
  const [pan, setPan] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Name:", name);
    console.log("PAN:", pan);
  };

  const handleNext = () => {
    navigate("/personalInformation");
    console.log("Next button clicked");
  };
  

  const handleBack = () => {
    navigate("/loanInformation");
    console.log("Back button clicked");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-lg shadow-lg w-[500px]"
      >
        <h2 className="text-2xl text-blue-900 font-bold mb-6 text-center">
          Validate your PAN
        </h2>
        
        {/* Name Field */}
        <div className="mb-6">
          <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
            Name as on PAN card:
          </label>
          <input
            id="name"
            type="text"
            placeholder="Enter exact name as on PAN"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-3 border rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* PAN Number Field */}
        <div className="mb-6">
          <label htmlFor="pan" className="block text-gray-700 text-sm font-bold mb-2">
            PAN Number:
          </label>
          <input
            id="pan"
            type="text"
            placeholder="Eg: ASDFG4567H"
            value={pan}
            onChange={(e) => setPan(e.target.value)}
            maxLength={10}
            className="w-full p-3 border rounded-lg text-gray-700 uppercase focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-between">
          <button
            type="button"
            onClick={handleBack}
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-3 px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            Back
          </button>

          <button
            type="button"
            onClick={handleNext}
            className="bg-blue-800 hover:bg-blue-900 text-white font-bold py-3 px-6 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Next
          </button>
        </div>
      </form>
    </div>
  );
};

export default PanForm;